exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.widget-step__swticher[data-v-1f1f0f89] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  gap: 20px;\n  margin-top: 10px;\n}\n.widget-step__swticher .md-disabled[data-v-1f1f0f89] {\n    cursor: not-allowed;\n}\n.widget-step__inner[data-v-1f1f0f89] .md-switch {\n  margin: 0;\n}\n.widget-step__inner[data-v-1f1f0f89] .vs__dropdown-menu {\n  z-index: 100;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f1f0f89","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/dashboard/widgets/WithdrawalWidget/SelectAsset.vue
// module id = aZOz
// module chunks = 1